import React from 'react';

const GitCommit = ({
  width = 16,
  height = 16,
  stroke = '#666666',
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      {...rest}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8H2.86667M13.1333 8H16M6.13333 5H9.86667C11.4131 5 12.6667 6.15127 12.6667 7.57143V8.42857C12.6667 9.84873 11.4131 11 9.86667 11H6.13333C4.58694 11 3.33333 9.84873 3.33333 8.42857V7.57143C3.33333 6.15127 4.58694 5 6.13333 5Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export { GitCommit };
